import Layout from '@/layout/index.vue';

export default [
  {
    path: '/assetOperation',
    name: 'assetOperation',
    component: Layout,
    meta: { title: '资产运营', icon: 'el-icon-s-finance' },
    children: [
      {
        path: 'fault_list',
        name: 'serverFaultList',
        component: () => import('@/views/appManage/poManage/fault_list.vue'),
        //服务器故障工单
        meta: { title: '入库-资产管理员', icon: 'el-icon-s-management' },
      },
      {
        path: 'retire',
        name: 'serverFaultRetire',
        component: () => import('@/views/appManage/retire_info.vue'),
        meta: { title: '出库-资产管理员', icon: 'el-icon-s-management' },
      },
      {
        path: 'migrateOrder',
        name: 'serverFaultMigrateOrder',
        component: () => import('@/views/appManage/retire_info.vue'),
        meta: { title: '挪库-资产管理员', icon: 'el-icon-s-order' },
      },
    ],
  },
];
